module.exports = __webpack_public_path__ + "static/img/new_logo.dbb449e.png";


//////////////////
// WEBPACK FOOTER
// ./src/core/login/img/new_logo.png
// module id = DVMJ
// module chunks = 0